module.exports = __webpack_public_path__ + "img/_54A2305.72e24afa.jpg";